import {Injectable}         from "@angular/core";
import { UtilitesService }  from "../../base-module/base-service/utilites.service";
import { AuthService }      from "../../base-module/base-service/auth.service";
import { Observable }       from "rxjs";
import {HttpClient}         from "@angular/common/http";

@Injectable()
export class ImportacaoArquivoService {

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Aporte do Cliente por id
     * @param id ID da Aporte do Cliente
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "movimentacao/arquivo-importacao/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Aporte do Cliente por id
     * @param id ID da Aporte do Cliente
     */
    getLastId(): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "movimentacao/arquivo-importacao/ultimo-arquivo", { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Aporte do Cliente
     * @param id ID da Aporte do Cliente
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "movimentacao/arquivo-importacao"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Aporte do Cliente
     * @param id ID da Aporte do Cliente
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "movimentacao/arquivo-importacao/"+id, { headers: this.authService.getAuthHeaders() });
    }
	
}
